module.exports = __webpack_public_path__ + "img/edit.png?b0d50a08d88103b7c5799a9171cabf8a";